export enum AppPermissionStatus {
    GRANTED = 'granted',
    DENIED = 'denied',
    DENIED_MOTION = 'denied-motion',
    DENIED_CAMERA = 'denied-camera',
    PROMPT = 'prompt'
  }

export type PermissionDeniedType = "motion" | "camera" | "mic";
 
  